import React, { useContext, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useQueryClient } from 'react-query';
import { FormControlLabel, Stack, Switch, Typography } from '@mui/material';

import { AppContext } from '../../../../context';
// import { translate as t } from 'hooks/useTranslations';
import useGroups from 'views/App/Portal/LexID/Groups/_data_sources/useGroups';
import useUserUserGroups from 'views/App/Portal/LexID/Users/_data_sources/useUserUserGroups';
import useManageUserUserGroup from 'views/App/Portal/LexID/Users/_data_sources/useManageUserUserGroup';
import { Group } from 'views/App/Portal/LexID/Groups/_types/group';
import Loading from 'views/App/Portal/Loading';
import errorHelper from 'helpers/errorHelper';

export default function Groups() {
  const { currentOrganizationId } = useContext(AppContext);
  const [isSaving, setIsSaving] = useState<boolean>(false);
  const queryClient = useQueryClient();
  //
  const { id } = useParams();
  const groupsQuery = useGroups(currentOrganizationId || '', { size: 100 });
  const userGroupsQuery = useUserUserGroups(currentOrganizationId || '', id || '');
  const { addGroup, removeGroup } = useManageUserUserGroup();

  const groups = React.useMemo(
    () => (groupsQuery.data && groupsQuery.data.pages ? groupsQuery.data.pages.flatMap((x: any) => x.content) : []),
    [groupsQuery.data]
  );

  const userGroups = React.useMemo(
    () => (userGroupsQuery.data && userGroupsQuery.data.groups ? userGroupsQuery.data.groups : []),
    [userGroupsQuery.data]
  );

  useEffect(() => {
    if (groupsQuery.hasNextPage) {
      groupsQuery.fetchNextPage();
    }
  }, [groupsQuery.data, groupsQuery.hasNextPage]);

  const handleGroupChange = (group: Group, isEnabled: boolean) => {
    setIsSaving(true);
    if (isEnabled) {
      addGroup(currentOrganizationId || '', id || '', group.id || '', () => {
        setIsSaving(false);
        queryClient.invalidateQueries(['user_user_groups', currentOrganizationId, id]);
      });
    } else {
      removeGroup(currentOrganizationId || '', id || '', group.id || '', () => {
        setIsSaving(false);
        queryClient.invalidateQueries(['user_user_groups', currentOrganizationId, id]);
      });
    }
  };
  if (groupsQuery.isError) {
    return errorHelper.renderErrors(groupsQuery);
  }

  if (userGroupsQuery.isError) {
    return errorHelper.renderErrors(userGroupsQuery);
  }

  return groupsQuery.isLoading || groupsQuery.isFetching || userGroupsQuery.isLoading || userGroupsQuery.isFetching ? (
    <Loading />
  ) : (
    <Stack spacing={2}>
      {groups.map((group) => (
        <FormControlLabel
          key={group.id}
          sx={{
            opacity: isSaving ? 0.5 : 1,
            pointerEvents: isSaving ? 'none' : 'auto',
          }}
          control={
            <Switch
              id={group.id}
              checked={userGroups.map((x) => x?.groupId).includes(group?.id)}
              onChange={({ target }) => handleGroupChange(group, target.checked)}
            />
          }
          label={
            <Stack>
              <Typography sx={{ fontWeight: 600 }}>{group.name}</Typography>
              {group.description?.length > 0 && <Typography variant='caption'>{group.description}</Typography>}
            </Stack>
          }
        />
      ))}
    </Stack>
  );
}
